/**
 * PC_TFB_01 
 * Importing the component, API and packages
 */
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import { postFeedBack, updateFeedBack, checkFeedback, getIndividualTouchbase } from "../../service/PerformanceAPI";

import { TeamMemberFeedback } from "../../components/TeamMemberFeedback";
import { ManagerFeedback } from "../../components/ManagerFeeback";
import { HrFeedback } from "../../components/HrFeedback";
import { connect } from 'react-redux'
import './Touchbase.css'
import moment from 'moment';
import Loader from '../../StaticComponent/Loader';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { NotificationTrigger, OnlyNumberSpecialChar } from '../../utils/RegHandling';
import { encryptStorage } from '../../constant'


function TouchbaseFeedbackForm({ websocket }) {

    const navigate = useNavigate()
    const { state } = useLocation()
    const { touchbaseId } = useParams()

    /**
   * PC_TFB_02
   * State variables are created
   */

    let dataObj = {
        touchbaseTitle: "", touchbaseDescription: "", touchbaseType: "",
        touchbaseDate: "", touchbaseStartTime: "", touchbaseEndTime: "", touchbaseStatus_id: "",
        touchbaseAttendees: "", touchbaseId: "", touchbaseStatus: "", manager_feedback: "", hr_feedback: "",
        manager_feedback_by: "", manager_feedback_by_id: "", hr_feedback_by: "", hr_feedback_by_id: "", employeeFeedback: "", createdBy: "", createdById: ""
    }
    let details = { role: "", roleId: "", week: 0, domain: "" }
    const [selectedPeopleList, setSelectedPeopleList] = useState([]);
    const [feedback, setFeedback] = useState(dataObj);
    const [pageMode, setPageMode] = useState(false);
    const [userDetails, setUserDetails] = useState(details)
    const [employeeFeedback, setEmployeeFeedback] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [breadCrumbsData, setbreadCrumbsData] = useState([])
    const [ManagerValidation, setManagerValidation] = useState()
    const [EmployeeValidation, setEmployeeValidation] = useState()
    const [HrManagerValidation, setHrManagerValidation] = useState()
    const [attendeesEmployeeId, setattendeesEmployeeId] = useState([])

    /**
    * PC_TFB_03
    * useEffect is invoked and then loadProfileRequest function is called
    */
    useEffect(() => {
        userDetails.roleId = encryptStorage.getItem("employeeId")
        userDetails.role = encryptStorage.getItem("role")
        userDetails.name = encryptStorage.getItem("username")
        userDetails.domain = encryptStorage.getItem("department")

        checkFeedback({ touchbaseId: touchbaseId }).then(res => {
            if (res.data.ResponseData != 0) {
                setPageMode(true)
            }
        })
        touchbaseLoadData()
    }, [touchbaseId])

    const touchbaseLoadData = async () => {
        if (touchbaseId) {
            setIsLoading(false)
            let res = await  getIndividualTouchbase({ "touchbaseId": touchbaseId })
                let validReportTo = false;
                if (res.data.ResponseData.created_by_id == encryptStorage.getItem('employeeId')) validReportTo = true;

            let arr = [];
            let list = [];
            res.data.ResponseData.attendees.forEach((element) => {
                arr.push(element.attendees);
                if (
                    element?.attendees == encryptStorage.getItem('employeeId') ||
                    element.attendees == encryptStorage.getItem('department')
                ) {
                    validReportTo = true;
                }
                let obj = {
                    value: element.attendees,
                    label: element.employee_name,
                    username: element.employee_name,
                };
                list.push(obj);
            });
            if (res.data.ResponseData.attendeeName.includes(encryptStorage.getItem('department'))) {
                validReportTo = true;
            }

            if (validReportTo) {
                setSelectedPeopleList(list);

                let individualData = {
                    touchbaseTitle: res.data.ResponseData.title,
                    touchbaseDescription: res.data.ResponseData.description,
                    touchbaseType: res.data.ResponseData.type,
                    touchbaseDate: res.data.ResponseData.touchabse_date,
                    touchbaseStartTime: res.data.ResponseData.start_time,
                    touchbaseEndTime: res.data.ResponseData.end_time,
                    touchbaseStatus_id: res.data.ResponseData.status_id,
                    touchbaseStatus: res.data.ResponseData.status,
                    touchbaseAttendees: res.data.ResponseData.attendeeName,
                    touchbaseId: res.data.ResponseData.id,
                    manager_feedback: res.data.ResponseData.manager_feedback,
                    manager_feedback_by: res.data.ResponseData.manager_feedback_by,
                    manager_feedback_by_id: res.data.ResponseData.manager_feedback_by_id,
                    hr_feedback: res.data.ResponseData.hr_feedback,
                    hr_feedback_by: res.data.ResponseData.hr_feedback_by,
                    hr_feedback_by_id: res.data.ResponseData.hr_feedback_by_id,
                    employeeFeedback: res.data.ResponseData.employeeFeedback,
                    createdBy: res.data.ResponseData.created_by,
                    color: res.data.ResponseData.color,
                    createdById: res.data.ResponseData.created_by_id,
                };
                arr.push(res.data.ResponseData.created_by_id);
                setattendeesEmployeeId(arr);

                setbreadCrumbsData(
                    userDetails.role == 'Team Member'
                        ? [
                            { title: 'Dashboard', path: '/overview', isActive: true },
                            { title: 'My Performance', path: '', isActive: true },
                            { title: 'Touchbase', path: '/touchbase', isActive: true },
                            { title: res?.data?.ResponseData?.title, path: '', isActive: false },
                        ]
                        : [
                            { title: 'Dashboard', path: '/overview', isActive: true },
                            { title: 'Team Member', path: '', isActive: true },
                            { title: 'Touchbase', path: '/touchbase', isActive: true },
                            { title: res?.data?.ResponseData?.title, path: '', isActive: false },
                        ]
                );
                setFeedback(individualData);
            } else {
                navigate('/', { state: { hideNav: false } });
            }
            setIsLoading(true);


        }

    }

    const OnChangeName = (value, key) => {
        switch (key) {
            case "Manager":
                feedback.manager_feedback = (value.managerFeedback)
                feedback.manager_feedback_by_id = (value.managerId)
                setFeedback({ ...feedback })

                break;
            case "Hr Manager":
                feedback.hr_feedback = (value.hrFeedback)
                feedback.hr_feedback_by_id = (value.hrId)
                setFeedback({ ...feedback })

                break;
            case "Team Member":
                let newEmployeeFeeback = []
                newEmployeeFeeback = value
                setEmployeeFeedback(newEmployeeFeeback)
                break;
        }
    }

    /**
   * PC_TFB_13, PC_TFB_15,PC_TFB_16,PC_TFB_17,PC_TFB_18,PC_TFB_19,PC_TFB_20
   * feedbackSubmit function is invoked when user click save button 
   * update API is called then based on the response user is redirect to request touchbase page
   */

    const validation = (role, data) => {
        //
        if (role === 'Team Member') {
            let check = true
            let result = data.employeeFeedback.some((element) => element.employee_id === userDetails.roleId && element.employee_feedback !== '')
            if (result === false) {
                check = false
                setEmployeeValidation('Enter the Feedback')
            }
            else {
                let filledFeedback = data.employeeFeedback.filter((element) => element.employee_id === userDetails.roleId && element.employee_feedback !== '')
                let checkregex = OnlyNumberSpecialChar(filledFeedback[0].employee_feedback.trim())
                if (checkregex) {
                    check = false
                    setEmployeeValidation("Feedback is not valid")
                } else {
                    setEmployeeValidation("")
                }
            }
            return check
        }
        else if (role === 'Manager') {
            let result = true
            if (data.managerFeedback === '' || data.managerFeedback === undefined || data.managerFeedback === null) {
                result = false
                setManagerValidation('Enter the Feedback')
            }
            else {
                let checkregex = OnlyNumberSpecialChar(data.managerFeedback.trim())
                if (checkregex) {
                    result = false
                    setManagerValidation("Feedback is not valid")
                } else {
                    setManagerValidation("")
                }

                return result
            }
        }
        else if (role === 'Hr Manager' || role === 'Hr') {
            let result = true
            if (data.hrFeedback === '' || data.hrFeedback === undefined || data.hrFeedback === null) {
                setHrManagerValidation('Enter the Feedback')
                result = false
            }
            else {
                let checkregex = OnlyNumberSpecialChar(data.hrFeedback.trim())
                if (checkregex) {
                    result = false
                    setHrManagerValidation("Feedback is not valid")
                } else {
                    setHrManagerValidation("")
                }
            }

            return result
        }
    }


    const feedbackSubmit = async () => {
        ////
        if (pageMode) {
            //
            let newEmployeeFeedback = []
            if (feedback.employeeFeedback !== undefined) {
                newEmployeeFeedback.push(...feedback.employeeFeedback)
            }
            let a = (employeeFeedback.length > 0) ? newEmployeeFeedback.push(...employeeFeedback) : []
            let updateData = {
                touchbaseId: touchbaseId,
                hrFeedback: feedback.hr_feedback,
                hrId: feedback.hr_feedback_by_id,
                managerFeedback: feedback.manager_feedback,
                managerId: feedback.manager_feedback_by_id,
                employeeFeedback: newEmployeeFeedback,
                touchbaseStatusId: feedback.touchbaseStatus_id,
                createdBy: feedback.createdById
            }
            let res = validation(userDetails.role, updateData)
            if (res) {



                let updateResponse = await updateFeedBack(updateData);

                if (updateResponse.data.ResponseData.Message == "Successfully updated") {
                    //
                    let index;
                    let notificationTo = updateResponse.data.ResponseData.notifyTo.filter((res, i) => {
                        if (res == userDetails.roleId) {
                            index = i
                            return res == userDetails.roleId
                        }

                    })
                    let notifiyTo = updateResponse.data.ResponseData.notifyTo
                    notifiyTo.splice(index, 1)

                    NotificationTrigger({ title: "Touchbase", message: 'Updated Feedback for a Touchbase', route: `/touchbasefeedback/${touchbaseId}`, to_employee: notifiyTo, by: userDetails.roleId }, notifiyTo, websocket).then(res => {
                        //
                        !state?.View ? navigate("/touchbase") : state?.redirect?.includes('tab') ?
                            window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=Touchbase` :
                            window.location.href = `/profilecontainer${state.redirect}&tab=Touchbase`
                    })
                }
            }
        } else {
            let postData = {
                touchbaseId: touchbaseId,
                hrFeedback: feedback.hr_feedback,
                hrId: feedback.hr_feedback_by_id,
                managerFeedback: feedback.manager_feedback,
                managerId: feedback.manager_feedback_by_id,
                employeeFeedback: employeeFeedback,
                touchbaseStatusId: feedback.touchbaseStatus_id,
                createdBy: feedback.createdById
            };
            let res = validation(userDetails.role, postData)
            if (res) {

                let postResponse = await postFeedBack(postData);
                if (postResponse.data.ResponseData == "Successfully inserted") {
                    //
                    let index;
                    let notificationTo = postResponse.data.notifyTo.filter((res, i) => {
                        if (res == userDetails.roleId) {
                            index = i
                            return res == userDetails.roleId
                        }
                    })
                    let notifiyTo = postResponse.data.notifyTo
                    notifiyTo.splice(index, 1)


                    NotificationTrigger({ title: "Touchbase", message: 'Feedback for a Touchbase', route: `/touchbasefeedback/${touchbaseId}`, to_employee: notifiyTo, by: userDetails.roleId }, notifiyTo, websocket).then(res => {
                        //
                        !state?.View ? navigate("/touchbase") : state?.redirect?.includes('tab') ?
                            window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=Touchbase` :
                            window.location.href = `/profilecontainer${state.redirect}&tab=Touchbase`
                    })
                }
            }

        }
    }

    const onChangeName = (e) => {
        setFeedback({ ...feedback, [e.target.name]: e.target.value });
    };

    return (
        <>
            {isLoading ?
                <div className="container-fluid coverpic mt-5">
                    <div className="row justify-content-around">
                        <div className="col-md-8 p-4 mt-5 bg-white rounded-3 mb-5">
                            {/* Breadcrumb section starts here */}
                            <BreadCrumbs data={breadCrumbsData} />
                            {/* Breadcrumb section ends here */}
                            <div className="touchbase-panel">
                                <img src="/Images/stopwatch.svg" className="me-3 touchbase-view-form-title" />
                                <label className="font-15 tt-bold touchbase-form-label mb-3">{feedback.touchbaseTitle}</label>
                                <p className="medium-text font-12 touchbase-feedback-text mb-4">
                                    {feedback.touchbaseDescription}
                                </p>
                                <div className="row mb-4 justify-content-between">
                                    <div className="col-auto ">
                                        <label className="mb-1 bold-text touchbase-form-label font-15">Attendees</label>
                                        <p className="touchbase-feedback-text medium-text font-15"><span><img className="touchbase-team-profile me-2" src="/Images/group-of-people.svg" alt="user-group" /></span>{feedback.touchbaseAttendees}</p>
                                    </div>
                                    <div className="col-auto">
                                        <label className="mb-1 bold-text touchbase-form-label font-15">Timeline</label>
                                        <p className="touchbase-feedback-text medium-text font-15"><span><img className="touchbase-team-profile me-2" src="/Images/time-period.svg" alt="time-icon" /></span>{moment((feedback.touchbaseStartTime), ["h:mm A"]).format("hh:mm A")} - {moment((feedback.touchbaseEndTime), ["h:mm A"]).format("hh:mm A")}</p>
                                    </div>
                                    <div className="col-auto">
                                        <label className="mb-1 bold-text touchbase-form-label font-15">Scheduled by</label>
                                        <p className="touchbase-feedback-text medium-text font-15"><span><img className="touchbase-user-profile me-2" src="/Images/logo-person-user-person-icon.jpg" alt="user-img" /></span>{feedback.createdBy}</p>
                                    </div>
                                    {(userDetails.role == "Manager") ? null :
                                        <div className="col-auto text-center">
                                            <label className="mb-1 bold-text touchbase-form-label font-15 text-left d-block">Status </label>
                                            <p className={`status-btn ${feedback.color} font-12 text-center`}>{feedback.touchbaseStatus}</p>
                                        </div>}
                                </div>
                                {/*HR Feedback*/}
                                <div className="mb-4 col-md-12">
                                    <label htmlFor="hr-feedback" className="form-label tt-bold font-15 bold-text touchbase-form-label ">HR Feedback</label>
                                    <HrFeedback status={feedback?.touchbaseStatus} onSubmit={(value, key) => OnChangeName(value, key)} Details={userDetails} HrFeedback={feedback.hr_feedback} HrFeedbackBy={feedback.hr_feedback_by} HrFeedbackById={feedback.hr_feedback_by_id} />
                                    <label className='text-danger'>{HrManagerValidation}</label>
                                </div>
                                {/*HR Feedback*/}
                                {/*Manager Feedback*/}
                                <div className="mb-4 col-md-12">
                                    <label className="font-15 tt-bold touchbase-form-label mb-2 ">Manager Feedback</label>
                                    <ManagerFeedback status={feedback?.touchbaseStatus} onSubmit={(value, key) => OnChangeName(value, key)} Details={userDetails} ManagerFeedback={feedback.manager_feedback} ManagerFeedbackBy={feedback.manager_feedback_by} />
                                    <label className='text-danger'>{ManagerValidation}</label>

                                </div>
                                {/*Manager Feedback*/}
                                {/*Team Member Feedback*/}
                                <div className="mb-3 col-md-12 border-bottom">
                                    <label className="font-15 tt-bold touchbase-form-label mb-2 ">Team Member Feedback</label>
                                    <TeamMemberFeedback status={feedback?.touchbaseStatus} onSubmit={(value, key) => OnChangeName(value, key)} EmployeeFeedback={feedback.employeeFeedback} Details={userDetails} />
                                    <label className='text-danger'>{EmployeeValidation}</label>
                                </div>
                                {/*Team Member Feedback*/}
                                <div className='row'>
                                    {(userDetails.roleId == feedback.createdById && feedback?.touchbaseStatus != 'Completed') ? <div className="col-md-3 mb-3">
                                        <label className="form-label hive-form-label" htmlFor="Leave_type">Status</label>
                                        <select className="form-select hive-form-select" aria-label="Default select example2" value={feedback.touchbaseStatus_id} onChange={(e) => { onChangeName(e) }} name='touchbaseStatus_id' >
                                            <option disabled={feedback.touchbaseStatus_id === '' ? false : true} selected>Select</option>
                                            {feedback.touchbaseStatus_id !== 2 ? <option value={1}>Yet to start</option> : null}
                                            <option value={2}>Delayed</option>
                                            <option value={3}>Completed</option>
                                        </select>
                                    </div> : null}
                                </div>
                                <div className="col-md-12 d-flex justify-content-end mt-5">

                                    <a href={!state?.View ? '/touchbase' : state?.redirect?.includes('tab') ? `/profilecontainer${state?.redirect?.split('tab')[0]}tab=Touchbase` : `/profilecontainer${state.redirect}&tab=Touchbase`}>
                                        <button type="button" className="btn hive-btn-secondary me-3">Cancel</button>
                                    </a>
                                    <button type="button" className=" btn hive-btn-primary" onClick={() => { feedbackSubmit() }} hidden={feedback.touchbaseStatus == "Completed"} >Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : <Loader isLoading={isLoading} />}
        </>
    )
}

function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(TouchbaseFeedbackForm)